<script>
  import Person from "./SpeakersWithEventDescription/Person.svelte";
  import Text from "./SpeakersWithEventDescription/Text.svelte";
  import { Clock, CFA } from "../../Components/Icons";

  export let item;
  export let id;

  export let firstPersonIsModerator = false;
  export let moderatorSalutatory = null;

  const speakers = {};
  [1, 2, 3, 4, 5, 6].forEach((number, index) => {
    speakers[number] = {
      moderator: !!(firstPersonIsModerator && index == 0),
      moderatorSalutatory: moderatorSalutatory,
      src: "//www.institutional-money.com/content/kgv/bilder/" + item[`referent${number}image`],
      name: item[`referent${number}imageTitle`],
      description: item[`referent${number}resume`],
    };
  });
</script>

<div class="my-6 bg-im-gray-200 p-3" {id}>
  {#if $$slots.headline}
    <h2 class="mb-2 text-lg font-bold"><slot name="headline" /></h2>
  {/if}
  {#if !item.referentCount}
    <Text {item} />
  {:else if item.referentCount == 1}
    <Text {item} persons={[speakers["1"]]} />
  {:else if item.referentCount == 2}
    <Text {item} persons={[speakers["1"], speakers["2"]]} />
  {:else if item.referentCount == 3}
    <Text {item} />
    <div class="flex flex-wrap gap-y-3 lg:justify-between">
      <Person {...speakers["1"]} />
      <Person {...speakers["2"]} />
      <Person {...speakers["3"]} />
    </div>
  {:else if item.referentCount == 4}
    <Text {item} persons={[speakers["1"]]} />
    <div class="flex flex-wrap gap-y-3 lg:justify-between">
      <Person {...speakers["2"]} />
      <Person {...speakers["3"]} />
      <Person {...speakers["4"]} />
    </div>
  {:else if item.referentCount == 5}
    <Text {item} persons={[speakers["1"]]} />
    <div class="flex flex-wrap gap-y-3 lg:justify-between">
      <Person {...speakers["2"]} small />
      <Person {...speakers["3"]} small />
      <Person {...speakers["4"]} small />
      <Person {...speakers["5"]} small />
    </div>
  {:else if item.referentCount == 6}
    <Text {item} persons={[speakers["1"], speakers["2"]]} />
    <div class="flex flex-wrap gap-y-3 lg:justify-between">
      <Person {...speakers["3"]} small />
      <Person {...speakers["4"]} small />
      <Person {...speakers["5"]} small />
      <Person {...speakers["6"]} small />
    </div>
  {/if}

  <div class="mt-4 flex flex-col gap-2 font-bold text-theme-minor-900 xs:flex-row xs:items-center xs:justify-between">
    <span class="flex items-center gap-2">
      {#if $$slots.date}
        <Clock class="h-4 w-4" />
        <slot name="date" />
      {/if}
    </span>

    {#if item.cfa_certified > 0}
      <CFA class="block max-w-[80px]" />
    {/if}
  </div>

  <div class="flex xs:justify-between">
    {#if $$slots.actions}
      <span class="mt-4">
        <slot name="actions" />
      </span>
    {/if}
    <a href="/kongress/mein-account#myEvents|overview" class="text-theme-signal">
      <svg class="svg-inline--fa fa-xl" aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <path
          d="M64 64C46.3 64 32 78.3 32 96v64H480V96c0-17.7-14.3-32-32-32H64zM32 192V416c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V192H32zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM128 256H384c8.8 0 16 7.2 16 16s-7.2 16-16 16H128c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 96H384c8.8 0 16 7.2 16 16s-7.2 16-16 16H128c-8.8 0-16-7.2-16-16s7.2-16 16-16zM352.2 90.3L384 109.3l31.8-19.1c7.6-4.5 17.4-2.1 21.9 5.5s2.1 17.4-5.5 22l-40 24c-5.1 3-11.4 3-16.5 0l-40-24c-7.6-4.5-10-14.4-5.5-22s14.4-10 21.9-5.5z"
        ></path>
      </svg>
    </a>
  </div>
</div>
